import {
  assetsUrl,
  CONTENT_TYPE,
  NAME_ANIMATION_POINTS,
  NAME_SOUND_ACTIVE,
  NAME_SOUND_ACTIVE_BANK,
  NAME_SOUND_CHARGE,
  NAME_SOUND_FAILURE,
  NAME_SOUND_HOVER,
  NAME_SOUND_LIVE,
  NAME_SOUND_SUCCESS,
} from "@educaplay/core";

// #region Sounds

export const LINE_UP_SOUND_PATHS = {
  // bankDeploy

  // hoverCheckButton

  // hoverCard
  // clickCard
  moveCard: assetsUrl("LINE_UP/mover.mp3"),
  placeCard: assetsUrl("LINE_UP/colocar.mp3"),

  cardLoad: assetsUrl("common/carga.mp3"),
  cardCorrect: assetsUrl("common/bien.mp3"),
  cardFail: assetsUrl("LINE_UP/fallo.mp3"),
  cardFailSmooth: assetsUrl("LINE_UP/vibrar.mp3"),
  answerFailSmooth: assetsUrl("LINE_UP/falloSuave.mp3"),

  // lifeLost
  checkAnswer: assetsUrl("common/activar.mp3"),
};

export const LINE_UP_SOUND_NAMES = {
  bankDeploy: NAME_SOUND_ACTIVE_BANK,

  hoverCheckButton: NAME_SOUND_HOVER,
  checkWrong: NAME_SOUND_FAILURE,
  checkRight: NAME_SOUND_SUCCESS,

  hoverCard: NAME_SOUND_HOVER,
  clickCard: NAME_SOUND_ACTIVE,
  moveCard: "moveCard",
  placeCard: "placeCard",

  cardLoad: NAME_SOUND_CHARGE,
  cardCorrect: "cardCorrect",
  cardFail: "cardFail",
  cardFail_smooth: "cardFailSmooth",
  answerFailSmooth: "answerFailSmooth",

  pointsUp: NAME_ANIMATION_POINTS,
  lifeLost: NAME_SOUND_LIVE,
  checkAnswer: "checkAnswer",
};

// #region Animations

const shakeAnims = {
  X: [
    "translate3d(0, 0, 0)", // 0
    "translate3d(-5px, 0, 0)", // 0.15
    "translate3d(5px, 0, 0)", // 0.3
    "translate3d(-5px, 0, 0)", // 0.45
    "translate3d(5px, 0, 0)", // 0.6
    "translate3d(-5px, 0, 0)", // 0.75
    "translate3d(5px, 0, 0)", // 0.9
    "translate3d(0, 0, 0)", // 1
  ],
  Y: [
    "translate3d(0, 0, 0)", // 0
    "translate3d(0, -5px, 0)", // 0.15
    "translate3d(0, 5px, 0)", // 0.3
    "translate3d(0, -5px, 0)", // 0.45
    "translate3d(0, 5px, 0)", // 0.6
    "translate3d(0, -5px, 0)", // 0.75
    "translate3d(0, 5px, 0)", // 0.9
    "translate3d(0, 0, 0)", // 1
  ],
  mix: [
    "translate3d(0, 0, 0)", // 0
    "translate3d(2.5px, -5px, 0)", // 0.15
    "translate3d(-5px, 5px, 0)", // 0.3
    "translate3d(5px, -2.5px, 0)", // 0.45
    "translate3d(0, 5px, 0)", // 0.6
    "translate3d(-5px, -5px, 0)", // 0.75
    "translate3d(2.5px, 0px, 0)", // 0.9
    "translate3d(0, 0, 0)", // 1
  ],
  tempo: [0, 0.15, 0.3, 0.45, 0.6, 0.75, 0.9, 1],

  X_smooth: [
    "translate3d(0, 0, 0)", // 0
    "translate3d(-1px, 0, 0)", // 0.1
    "translate3d(2px, 0, 0)", // 0.2
    "translate3d(-4px, 0, 0)", // 0.3
    "translate3d(4px, 0, 0)", // 0.4
    "translate3d(-4px, 0, 0)", // 0.5
    "translate3d(4px, 0, 0)", // 0.6
    "translate3d(-4px, 0, 0)", // 0.7
    "translate3d(2px, 0, 0)", // 0.8
    "translate3d(-1px, 0, 0)", // 0.9
    "translate3d(0, 0, 0)", // 1
  ],
  Y_smooth: [
    "translate3d(0,  0,   0)", // 0
    "translate3d(0, -1px, 0)", // 0.1
    "translate3d(0,  2px, 0)", // 0.2
    "translate3d(0, -4px, 0)", // 0.3
    "translate3d(0,  4px, 0)", // 0.4
    "translate3d(0, -4px, 0)", // 0.5
    "translate3d(0,  4px, 0)", // 0.6
    "translate3d(0, -4px, 0)", // 0.7
    "translate3d(0,  2px, 0)", // 0.8
    "translate3d(0, -1px, 0)", // 0.9
    "translate3d(0,  0,   0)", // 1
  ],
  tempo_smooth: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
  bezierEasing: [0.36, 0.07, 0.19, 0.97],
};

const bounceAnim = {
  scale: ["scale(1)", "scale(1)", "scale(1.1)", "scale(1)"],
  // 0.33s delay + 0.66 resto * 0.61 porcentaje original = timestamp intermedio
  tempo: [0, 0.33, 0.33 + 0.61 * 0.66, 1],
};

export const ANIMATION_DURATIONS = {
  // Delay per card
  correctCardStagger: 0.5,
  correctCardStagger_ms: 500,

  wrongCardStagger: 0.2,
  wrongCardStagger_ms: 200,

  // Animation times
  // Bounce when correct
  correctionBounce: 0.3,
  correctionBounce_ms: 300,

  // Shake when wrong
  correctionShake: 0.35,
  correctionShake_ms: 350,

  // Shake no lives
  correctionShake_smooth: 0.82,
  correctionShake_smooth_ms: 820,

  // Back to default after shake
  correctionBackToDefault: 0.2,
  correctionBackToDefault_ms: 200,

  // Shadow changes when hovered / clicked / dragged
  cardShadowTransition: 0.2,
  cardShadowTransition_ms: 200,

  // Layout modify duration (when dragging)
  dndSwap: 0.4,
  dndSwap_ms: 400,

  // Release dragged card, time to final position
  // TODO: SCSS export for /components/DraggableBox/dragBox.module.scss
  dragOverlayDrop: 0.15,
  dragOverlayDrop_ms: 150,

  // Point - life delay
  life2PointDelay: 1.2,
  life2PointDelay_ms: 1200,

  // New screens - card spawn duration and stagger
  cardSpawn: 0.2,
  cardSpawn_ms: 200,

  // Hold time to drag
  holdTime2Drag: 0.2,
  holdTime2Drag_ms: 200,
};

export const CARD_STATES = {
  default: {
    backgroundColor: "var(--element-background-color)",
    color: "var(--element-text-color)",

    borderColor: "var(--element-border-color)",
    "--fillPlayer": "var(--primary-color)",
    "--fillMusic": "var(--primary-color)",

    transition: {
      duration: ANIMATION_DURATIONS.cardShadowTransition,
    },
  },
  ok: {
    backgroundColor: "var(--game-success-color)",
    color: "var(--success-text-color)",
    borderColor: "var(--game-success-color)",

    "--fillPlayer": "var(--success-text-color)",
    "--fillMusic": "var(--success-text-color)",

    zIndex: -1,
  },
  wrong: {
    backgroundColor: "var(--game-error-color)",
    color: "var(--error-text-color)",
    borderColor: "var(--game-error-color)",

    "--fillPlayer": "var(--error-text-color)",
    "--fillMusic": "var(--error-text-color)",

    zIndex: 0,
  },
};

export const CARD_ANIMS = {
  bounce: {
    anim: {
      ...CARD_STATES.ok,

      zIndex: [null, 0, 1, -1],
      transform: bounceAnim.scale,
    },
    transition: {
      duration: ANIMATION_DURATIONS.correctionBounce,
      times: bounceAnim.tempo,
    },
  },
  shake: {
    anim: {
      ...CARD_STATES.wrong,

      transform: shakeAnims.mix,
    },

    transition: {
      duration: ANIMATION_DURATIONS.correctionShake,
      times: shakeAnims.tempo,
    },
  },
  shakeX_smooth: {
    anim: {
      transform: shakeAnims.X_smooth,
    },

    transition: {
      duration: ANIMATION_DURATIONS.correctionShake_smooth,
      times: shakeAnims.tempo,
      ease: shakeAnims.bezierEasing,
    },
  },
  shakeY_smooth: {
    anim: {
      transform: shakeAnims.Y_smooth,
    },

    transition: {
      duration: ANIMATION_DURATIONS.correctionShake_smooth,
      times: shakeAnims.tempo,
      ease: shakeAnims.bezierEasing,
    },
  },
  default: {
    anim: {
      ...CARD_STATES.default,
    },
    transition: { duration: ANIMATION_DURATIONS.correctionBackToDefault },
  },
};

// #region Logic

export const CARD_CORRECTIONS = {
  uncheked: "no",
  ok: "ok",
  locked: "nometokes",
  wrong: "bad",
};

export const CARD_TYPES = {
  ...CONTENT_TYPE,
  AUDIOTEXT: "audioText",
  IMAGETEXT: "imgText",
};
